import APIClient from '@/shared/http/clients/api'

const resourceName = 'REEmpreendimentoUnidadePreco'
const APIBaseURLRealEstate = process.env.APIBaseURLRealEstate

const GetAllTablePrice = (limit, index, data = {}, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}/?limit=${limit}&index=${index}`, data, config)
const GetAllOptions = (data = {}, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}/GetAllOptions`, data, config)
const ImportableByEmpreendimento = (id, data = {}, config = {}) => APIClient.post(`${APIBaseURLRealEstate}/${resourceName}/ImportableByEmpreendimento/${id}`, data, config)
const ImportableByEmpreendimentoTipo = (id, data = {}, config = {}) => APIClient.post(`${APIBaseURLRealEstate}/${resourceName}/ImportableByEmpreendimentoTipo/${id}`, data, config)
const SaveTabelaPdf = (id, data = {}, config = {}) => APIClient.post(`${APIBaseURLRealEstate}/${resourceName}/SaveTabelaPdf/${id}`, data, config)
const RemovePdf = (id, data = {}, config = {}) => APIClient.delete(`${APIBaseURLRealEstate}/${resourceName}/RemovePdf/${id}`, data, config)
const GetPdf = (id, data = {}, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}/GetPdf/${id}`, data, config)
const DownloadPdf = (id, data = {}, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}/documentos/download/${id}`, data, config)
const DownloadPdfbyId = (EnterpriseId, data = {}, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}/DownloadPdfbyId/${EnterpriseId}`, data, config)
const GetAllOptionsByEnterpriseId = (id, data = {}, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}/GetAllOptionsByEnterpriseId/${id}`, data, config)

const priceunityenterpriseRepository = {
  GetAllTablePrice,
  GetAllOptions,
  ImportableByEmpreendimento,
  ImportableByEmpreendimentoTipo,
  SaveTabelaPdf,
  RemovePdf,
  GetPdf,
  DownloadPdf,
  DownloadPdfbyId,
  GetAllOptionsByEnterpriseId
}

export default priceunityenterpriseRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/realestate/priceunityenterprise.js